// Client Book: relationships. The three-tier Relationships tab of the client
// record (`wealth.crm.client-book.relationships`, ADR-0027, SEP-177).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const RelationshipsTabSlot = lazy(() =>
    import('./client-book.slots').then((m) => ({ default: m.RelationshipsTabSlot })),
);

export default defineWebFeature({
    id: 'wealth.crm.client-book.relationships',
    slots: {
        'client.detail.tabs': [
            {
                key: 'relationships',
                order: 20,
                label: 'Relationships',
                Component: RelationshipsTabSlot,
            },
        ],
    },
});
